import { create as createStore } from "zustand"

type YouTubeJsState = {
  loaded: boolean
  player: YTPlayer | null
}

const defaultState: YouTubeJsState = {
  loaded: false,
  player: null,
}

const store = createStore(() => defaultState)

export function setYouTubeJsLoaded() {
  store.setState({ loaded: true })
}

export function setYouTubePlayer(player: YTPlayer) {
  store.setState({ player })
}

export function pauseYouTubeVideo() {
  const { player } = store.getState()
  console.debug("📼 YT pauseVideo", player?.videoTitle)

  if (typeof player?.pauseVideo === "function") {
    player.pauseVideo()
  }
}

export function playYouTubeVideo() {
  const { player } = store.getState()
  console.debug("📼 YT playVideo", player?.videoTitle)

  if (typeof player?.playVideo === "function") {
    player.playVideo()
  }
}
